var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AppState } from "@/share/AppState";
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { action, makeObservable, observable } from "mobx";
import { AppConstants } from "@@/Constants";
import { Router } from "./Router";
export class AuthStore {
    constructor() {
        this.appstate = AppState.Unknown;
        this.registerTypes = [];
        this.username = "Welcome";
        this.showLoginViaDevice = false;
        this.isAdmin = false;
        this.userid = "";
        this.sessionid = "";
        this.deviceid = "";
        this.registeredClient = false;
        makeObservable(this);
        APPEvent.addSubscriberForAppState((state) => this.setAppState(state));
        APPEvent.addSubscriberForUserID((id) => this.userid = id);
        APPEvent.addSubscriberForRegisterTypes((types) => this.setLoginTypes(types));
        APPEvent.addSubscriberForUserName(name => this.setUserName(name));
        APPEvent.addSubscriberForIsAdmin((admin) => this.setIsAdmin(admin));
        APPEvent.addSubscriberForDeviceid((id) => this.deviceid = id);
        APPEvent.addSubscriberForSessionid((id) => this.sessionid = id);
    }
    getTenantId() {
        return this.userid.split(AppConstants.TenantSep)[0];
    }
    setIsAdmin(isadmin) {
        this.isAdmin = isadmin;
    }
    setShowLoginViaDevice(show) {
        this.showLoginViaDevice = show;
    }
    isRegisteredClient() {
        return this.registeredClient;
    }
    setUserName(name) {
        this.username = name;
    }
    setLoginTypes(types) {
        this.registerTypes = types;
    }
    setAppState(state) {
        if (this.appstate !== AppState.APPDown) {
            this.appstate = state;
        }
        if (this.appstate === AppState.Register) {
            APPEvent.publishForReset();
        }
        if (this.appstate === AppState.LoggedIn) {
            Router.parseUrlHash();
            Apphandler.sendMessage("isadmin", "");
        }
    }
    checkAppState() {
        Apphandler.sendMessage("checkappstate", "check state");
    }
    wipe() {
        Apphandler.sendMessage("deletethisdevice", "delete");
        setTimeout(() => APPEvent.publishForReset(), 1000);
    }
    logout() {
        APPEvent.publishForReset();
        APPEvent.publishAppState(AppState.Login);
        Apphandler.sendMessage("logout", "");
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], AuthStore.prototype, "appstate", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AuthStore.prototype, "registerTypes", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AuthStore.prototype, "username", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AuthStore.prototype, "showLoginViaDevice", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AuthStore.prototype, "isAdmin", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AuthStore.prototype, "setIsAdmin", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AuthStore.prototype, "setShowLoginViaDevice", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AuthStore.prototype, "setUserName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], AuthStore.prototype, "setLoginTypes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AuthStore.prototype, "setAppState", null);
